export const CHANNEL = "pr";

/** The Google rating the site quotes until an admin sets it (Admin → Settings →
 *  Hero banner, `getHeroBanner()` in admin/lib/settings.ts). The hero line,
 *  <ReviewCounter> and the home page's AggregateRating JSON-LD all read that one
 *  value, so the figures can't drift apart (a rich-result violation once already). */
export const GOOGLE_REVIEWS = {
    rating: "5.0",
    count: 1600,
    url: "https://maps.app.goo.gl/bb6QTDM1eE66Mgtz7",
};